<template>
    <AttachOperation></AttachOperation>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const AttachOperation = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/JobEntry/AttachOperation.vue"
    )
);

export default {
    name: "Project_HelpAttachOperation", //The name you are in should not equal the name of the component you are importing.
    components: { AttachOperation, AuthLayout },
};
</script>
